import {
  WhatsappDraftTemplate,
  WhatsappFrontTemplateObject,
  WhatsappOriginalTemplate,
  WhatsappTemplate,
  WhatsappTemplateMessageComponents,
} from 'types/templates';
import { TemplateVarsData } from 'types/templates/templates-menu';
import { fetcher } from 'utils/axios';

export async function updateTemplateHebrewName(templateOriginalName: string, templateHebrewName: string) {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/services/updateWhatsappTemplateName',
        {
          data: {
            templateOriginalName,
            templateHebrewName,
          },
        },
      ],
      'history',
    );
    return data;
  } catch (error) {
    console.warn('updateTemplateHebrewName error: ', error);
    return null;
  }
}
export async function fetchTemplateVarsData(template: WhatsappTemplate) {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/make/GetTemplateWithMediaDataFromObject',
        {
          data: {
            templateObject: template,
          },
        },
      ],
      'app',
    );
    return data;
  } catch (error) {
    console.warn('getTemplateVarsData error: ', error);
    return null;
  }
}

export type GetTemplateFormattedObjectParams = {
  templateObject?: WhatsappTemplate;
  templateOriginalObject: WhatsappOriginalTemplate;
  to: string;
  templateVars: Record<TemplateVarsData[0]['name'], string>;
  fileName?: string;
};
export async function getTemplateFormattedObject(params: GetTemplateFormattedObjectParams) {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/make/GetTemplateFormattedObject',
        {
          data: params,
        },
      ],
      'app',
    );
    return {
      frontTemplateObj: data.frontTemplateObj as WhatsappFrontTemplateObject,
      components: data.components as WhatsappTemplateMessageComponents,
    };
  } catch (error) {
    console.warn('getTemplateFormattedObject error: ', error);
    return null;
  }
}

export type FetchSendTemplateMessageParams = {
  to: string;
  templateName: string;
  languageCode: string;
  components: string;
  frontTemplateObj: string;
  userglobalid: string;
  templateText: string;
  isMediaPlaceholder?: boolean;
  isVars?: boolean;
  TempId?: string;
  procData?: string | null;
  source?: string;
};
export async function fetchSendTemplateMessage(params: FetchSendTemplateMessageParams) {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/make/SendReadyWhatsappTemplateMessage',
        {
          data: { ...params, source: 'front' },
        },
      ],
      'app',
    );
    if (data)
      return data as {
        result: boolean;
        message: string;
      };
    else return null;
  } catch (error) {
    console.warn('fetchSendTemplateMessage error: ', error);
    return null;
  }
}

//* drafts
export async function getDraftTemplates() {
  try {
    const data = await fetcher('get', '/api/wa-business/getDraftTemplates', 'history');

    if (data)
      return data as {
        result: boolean;
        templates: Array<WhatsappDraftTemplate>;
      };
    else return null;
  } catch (error) {
    console.warn('getDraftTemplates error: ', error);
    return null;
  }
}
export async function createUpdateTemplateDraft(
  templateOriginalName: string,
  templateHebrewName: string,
  DraftTemplatObject: string,
  draftId?: number,
) {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/wa-business/createUpdateTemplateDraft',
        {
          data: {
            templateOriginalName,
            templateHebrewName,
            DraftTemplatObject,
            draftId,
          },
        },
      ],
      'history',
    );
    if (data)
      return data as {
        result: boolean;
        id: number;
      };
    else return null;
  } catch (error) {
    console.warn('createUpdateTemplateDraft error: ', error);
    return null;
  }
}
export async function deleteDraftTemplate(id: number) {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/wa-business/deleteTemplateDraft',
        {
          data: {
            draftId: id,
          },
        },
      ],
      'history',
    );
    if (data)
      return data as {
        result: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('deleteDraftTemplate error: ', error);
    return null;
  }
}
export async function fetchGetDraftTemplateById(id: string) {
  try {
    const data = await fetcher(
      'get',
      [
        '/api/wa-business/getDraftTemplatebyId',
        {
          data: {
            id,
          },
          // skipServerContext: true,
        },
      ],
      'history',
    );
    if (data)
      return data as {
        result: boolean;
        template: WhatsappDraftTemplate;
      };
    else return null;
  } catch (error) {
    console.warn('fetchGetDraftTemplateById error: ', error);
    return null;
  }
}
